import { useQuery } from '@tanstack/react-query';
import { opportunityService } from '../../../services/opportunityService';

export const OPPORTUNITIES_QUERY_KEY = ['opportunities'] as const;

export const useOpportunitiesQuery = () =>
  useQuery({
    queryKey: OPPORTUNITIES_QUERY_KEY,
    queryFn: () => opportunityService.getAll(),
    staleTime: 60_000,
  });
